import { Alert, AlertTitle, Snackbar } from "@mui/material";
import { Transition } from "../../pages/app/utils/animation";
import { useAlerts } from "../../store/alerts/hooks";

export const StipaAlert = () => {
  const { showStipaAlert, closeStipaAlert } = useAlerts();

  return (
    <Snackbar
      open={showStipaAlert}
      onClose={() => closeStipaAlert()}
      autoHideDuration={5000}
      message="This Snackbar will be dismissed in 5 seconds."
      slots={{
        transition: Transition,
      }}
      sx={{
        "&.MuiSnackbar-root": {
          transform: "translate(-50%, -50%)",
          top: "50%",
          left: "50%",
        },
      }}
    >
      <Alert
        onClose={() => closeStipaAlert()}
        severity="info"
        variant="outlined"
        sx={{ bgcolor: "background.paper", boxShadow: 3 }}
      >
        <AlertTitle>Please upload a single channel clip.</AlertTitle>A single
        channel clip is required to perform this action.
      </Alert>
    </Snackbar>
  );
};
